export default {
    l_User_name: "User name",
    l_Phone: "Phone",
    l_User_password: "User password",
    l_Forgot_password: "Forgot password",
    l_Login: "Log in",
    l_Sign_out: "Sign out",
    l_EmailorPasswordisWrong: "Email or passwordis wrong",
    l_User: "User",
    l_Payments: "Payments",
    l_Promocodes: "Promocodes",
    l_Messages: "Messages",
    l_Consolidations: "Consolidations",
    l_Courier_Orders: "Courier Orders",
    l_Almaty: "Almaty",
    l_Temu_return_back: "Temu return back",
    l_Name: "Name",
    l_Add: "Add",
    l_On_shelf: "On shelf",
    l_Action: "Action",
    l_Return_excel: "Return M-Batch Excel",
    l_Update: "Update",
    l_Remark_time: "Remark time",
    l_Remark_JPID: "Remark JPID",
    l_Accepted_JPID: "Accepted JPID",
    l_Accepted_stationCode: "Accepted Stationcode",
    l_Remark_stationCode: "Remark Stationcode",
    l_Edit: "Edit",
    l_Submit: "Submit",
    l_Total_weight: "Total weight",
    l_Medium_batch_count: "Medium batch count",
    l_Cancel: "Cancel",
    l_Last_trackcodes: "Last trackes",
    l_Are_you_sure_delete_this_task: "Are you sure delete this task?",
    l_Yes: "Yes",
    l_No: "No",
    l_Tracking_number: "Tracking number",
    l_Internal_Tracking_number: "Internal Tracking number",
    l_Actual_Price: "Actual Price",
    l_Estimated_price: "Estimated price",
    l_Actual_weight: "Actual weight",
    l_kg: "kg",
    l_Estimated_weight: "Estimated weight",
    l_Delivery_country: "Delivery country",
    l_Delivery_type: "Delivery type",
    l_Address: "Address",
    l_Execution_status: "Execution reason-status",
    l_Cargo: "Cargo",
    l_Sign_up: "Sign up",
    l_Next: "Next",
    l_Verify_code: "Verify code",
    l_Set_password: "Set password",
    l_Confirm_password: "Confirm password",
    l_Get_SMS: "Get SMS",
    l_Get_the_verification_code_first: "Get the verification code first",
    l_Confirm_password_error: "Confirm password error",
    l_Phone_number: "Phone number",
    l_Password: "Password",
    l_Wrong_password_format: "Wrong password format",
    l_Please_enter_phone_number: "Please enter phone number",
    l_Please_enter_sms: "Please enter SMS",
    l_My_addresses: "My addresses",
    l_My_parcels: "My parcels",
    l_Buy_instead_of_me: "Buy instead of me",
    l_Personal_data: "Personal data",
    l_Update_password: "Update password",
    l_Old_Password: "Old password",
    l_New_Password: "New password",
    l_Successed: "Successed",
    l_Personal_information: "Personal information",
    l_User_list: "User list",
    l_Email: "Email",
    l_Add_user: "Add user",
    l_Full_name: "Full name",
    l_IIN: "IIN",
    l_ID_number: "ID number",
    l_Issuing_authority: "Issuing authority",
    l_Issue_date: "Issue date",
    l_Validity: "Validity",
    l_Delivery_address: "Delivery address",
    l_Town: "City/Town",
    l_Street: "Street",
    l_House: "House",
    l_Postcode: "Postcode",
    l_Identity_card: "Identity card",
    l_Facial: "Facial",
    l_Negotiable: "Negotiable",
    l_Draw_a_signature: "Draw a signature",
    l_Or_download_the_signed_contract: "Or download the signed contract",
    l_Note: "Note",
    l_Precautions_for_uploading_pictures: "The attached document must be of good quality. The image file must not exceed 1 MB.",
    l_Click_or_drag_ile_to_this_area_to_upload: "Click or drag file to this area to upload",
    l_My_order: "My order",
    l_Track_code: "Track code",
    l_Recipient: "Verified",
    l_Cargo_name: "Cargo name",
    l_Declared_price: "Declared price",
    l_Date: "Date",
    l_Delivery_cost: "Delivery cost",
    l_Dispatch_country: "Dispatch country",
    l_Delivery_method: "Delivery method",
    l_Order: "Order",
    l_Shipping_country: "Shipping country",
    l_Transportation_method: "Transportation method",
    l_Price: "Price",
    l_Quantity: "Quantity",
    l_Total_cost: "Total cost",
    l_Category: "Category",
    l_Weapons_and_explosive_materials: "Weapons and explosive materials",
    l_Alcoholic_drinks: "Alcoholic drinks",
    l_Sprays_and_aerosols: "Sprays and aerosols",
    l_Medicines_without_a_doctors_prescription: "Medicines without a doctor's prescription",
    l_radioactive_elements: "radioactive elements",
    l_Animals_and_plants: "Animals and plants",
    l_ALL_RIGHTS_RESERVED: "ALL RIGHTS RESERVED",
    l_Contact: "Contact",
    l_About_us: "About us",
    l_The_shops: "The shops",
    l_How_it_works: "How it works?",
    l_Rates: "Rates",
    l_Frequently_asked_Questions: "Frequently asked Questions",
    l_Prohibited_Items: "Prohibited Items",
    l_Privacy_Policy: "Privacy Policy",
    l_Weight: "Weight",
    l_Declaration: "Declaration",
    l_Pay: "Pay",
    l_Provinces: "Provinces",
    l_Country: "Country",
    l_Full_address: "Full address",
    l_MY_ADDRESS_IN_CHINA_FOR_AUTO_DELIVERY: "MY ADDRESS IN CHINA FOR AUTO DELIVERY",
    l_Add_product: "Add cargo",
    l_Please_enter_quantity: "Please enter quantity",
    l_The_maximum_number_is: "The maximum number is",
    l_China: "China",
    l_Auto_delivery: "Auto delivery",
    l_To_avoid_problems_during_customs_clearance_please_enter_a_detailed_description_of_the_product_name_in_Russian: "To avoid problems during customs clearance, please enter a detailed description of the product name in Russian.",
    l_Later_confirm: "Later Confirm",
    l_Confirm: "Confirm",
    l_Succeed: "Succeed",
    l_Provide_a_link_to_the_product_we_will_buy_and_bring_it_for_you: "Provide a link to the product, we will buy and bring it for you!",
    l_Cargo_link: "Cargo link",
    l_Additional_comment: "Additional comment",
    l_Are_you_willing_to_buy_if_the_price_fluctuates_up_to_7: "Are you willing to buy if the price fluctuates up to 7% ?",
    l_size: "Size",
    l_Color: "Color",
    l_Delivery_price: "Delivery price",
    l_Promo_codes: "Promo codes",
    l_Whether_the_payment_is_completed: "Whether the payment is completed?",
    l_Completed: "Completed",
    l_Not_completed: "Not completed",
    l_Image_must_smaller_than_3MB: "Image must smaller than 3MB!",
    l_Image_must_smaller_than_2MB: "Image must smaller than 2MB!",
    l_Image_format_error: "image format error!",
    l_Analytics: "Analytics",
    l_Status: "Status",
    l_Order_id: "Order id",
    l_Traking_number: "Traking number",
    l_Amount: "Amount",
    l_Payment_metehod: "Payment metehod",
    l_Payment: "Payment",
    l_First_name: "First name",
    l_Last_name: "Last name",
    l_Type: "Type",
    l_Client: "Client",
    l_Admin: "Admin",
    l_Last_login: "Last login",
    l_Register: "Register",
    l_Verified: "Verified",
    l_Not_verified: "Verification failed",
    l_All: "All",
    l_Search: "Search",
    l_Statuses: "Statuses",
    l_Start_country: "Start country",
    l_End_country: "End country",
    l_Sort: "Sort",
    l_Add_time: "Add time",
    l_Update_time: "Update time",
    l_Ascending: "Ascending",
    l_Descending: "Descending",
    l_Create_time: "Create time",
    l_Message: "Message",
    l_Send_message: "Send message",
    l_Internal_tracking_number: "Internal tracking number",
    l_Shopping_instead: "Shopping instead",
    l_Size: "Size",
    l_Description: "Description",
    l_Link: "Link",
    l_City: "City",
    l_All_cargo: "All cargo",
    l_Volume: "Volume",
    l_Height: "Height",
    l_Paid: "Paid",
    l_Unpaid: "Unpaid",
    l_Declaration_verify: "Declaration verify",
    l_Update_date: "Update date",
    l_Add_date: "Add date",
    l_Add_to_consolidation: "Add to consolidation",
    l_Consolidation: "Consolidation",
    l_Consolidation_id: "Consolidation ID",
    l_Add_type: "Add type",
    l_Add_new: "Add new",
    l_Contractor: "Contractor",
    l_Selected_order_quantity: "Selected order quantity",
    l_Flight_number: "Flight number",
    l_Execution_date: "Execution date",
    l_Document: "Document",
    l_Add_order: "Add order",
    l_Can_choose_to_consolidation: "Can choose to consolidation",
    l_Amount_paid: "Amount paid",
    l_Payment_method: "Payment method",
    l_Card: "Card",
    l_Cash: "Cash",
    l_External_ID: "External ID",
    l_Verification_succeeded: "Verification succeeded",
    l_Verification_failed: "Verification failed",
    l_Car_number: "Car number",
    l_trailer_car_number: "Trailer car number",
    l_Foreign_warehouse: "Foreign warehouse",
    l_Almaty_warehouse: "Almaty warehouse",
    l_Info: "Info",
    l_Payment_amount: "Payment amount",
    l_Automatic_storage_filter_cleared_when_refresh: "Automatic storage filter, cleared when refresh",
    l_Not_found: "Not found",
    l_Contract_template: "Contract template",
    l_File_format_error: "File format error!",
    l_Back_home_page: "Back Home",
    l_Picked_up: "Picked up",
    l_Not_picked_up: "Not picked up",
    l_Payment_status: "Payment reason-status",
    l_Ready_to_ship: "Ready_to_ship",
    l_Belongs_category: "Belongs category",
    l_File: "File",
    l_Poster: "Poster",
    l_format_error: "Format error",
    l_TN_CODE: "TNVED code",
    l_Other: "Other",
    l_Company: "Company",
    l_Order_tracking: "Order tracking",
    l_Not_fount: "Not fount",
    l_Submit_and_print_label: "Submit and print label",
    l_Are_you_sure_update_password: "Are you sure update password?",
    l_Print_: "Print",
    l_Operator: "Operator",
    l_Russian_language: "Russian language",
    l_Print_label: "Print label",
    l_Warehouse: "Warehouse",
    l_Checking: "Under review",
    l_Verification_failed_description: "Failure reason",
    l_App_version: "App version",
    l_App_version_title: "Version title",
    l_App_version_content: "Version content",
    l_App_version_system: "App system",
    l_Version: "Version number",
    l_Force_update: "Need to force update?",
    l_Published: "Published",
    l_Unpublished: "Unpublished",
    l_Select: "Select",
    l_Gross_weight: "Gross weight",
    l_Join_warehouse: "Join warehouse",
    l_Batch_number: "Batch number",
    l_Unclaimed_order: "Unclaimed order",
    l_China_batch: "CN batch",
    l_Reject_order: "Reject order",
    l_Mini_batch: "Mini batch",
    l_Kazakhstan_batch: "KZ batch",
    l_Branch_warehouse: "Branch",
    l_Driver: "Driver",
    l_Dest_station: "Dest station",
    l_Batch: "Batch",
    l_Shelf: "Shelf",
    l_Add_to_shelf: "Add to shelf",
    l_Data: "Data",
    l_Settings: "Settings",
    l_Creator: "Creator",
    l_Shelf_number: "Shelf number",
    l_Sorting_center: "Sorting center",
    l_Pick_up: "Pick up",
    l_Scan: "Scan",
    l_Last_six_digits_of_mobile_number: "Last six digits of mobile number",
    l_Branch_batch: "Branch batch",
    l_Arrived_to_branch: "Arrived to branch",
    l_Arrived: "Arrived",
    l_Export_excel: "Export Excel",
    l_Work_time: "Work time",
    l_Manager: "Manager",
    l_Province: "Province",
    l_Remark: "Remark",
    l_Start: "Start",
    l_End: "End",
    l_Do_not_add_randomly: "Do not add randomly!",
    l_Find_branch: "Find branch",
    l_Refresh: "Refresh",
    l_Has_photo: "Has photo",
    l_Valid_time: "Valid until",
    l_Info_api: "Info API",
    l_Visible_state: "Visible state",
    l_File_update_time: "File update time",
    l_Time: "Time",
    l_Created: "Created",
    l_Group_payment: "Group payment",
    l_Permission: "Permission",
    l_System: "System",
    l_Tag: "Tag",
    l_Road_type: "Road type",
    l_Official: "Official",
    l_Commerce: "Commerce",
    l_Recommended_shelf: "Recommended shelf",
    l_Amount_payable_by_the_client: "Amount payable by the client",
    l_Payment_completed: "Payment completed",
    l_Error_batch: "Error batch",
    l_Error_order: "Error order",
    l_Error_mini_batch: "Error mini batch",
    l_Work: "Work",
    l_China_logistics: "China logistics",
    l_Receiver: "Receiver",
    l_Transport_day: "Transport day",
    l_Day: "Day",
    l_tel_merge: "Phone number merging",
    l_Abnormal_order: "Abnormal order",
    l_Customs: "Customs",
    l_Contract: "Contract",
    l_Invoice: "Invoice",
    l_Filter: "Filter",
    l_CN_category_id: "CN category id",
    l_Prohibited_catgegories: "Prohibited categories",
    l_Error: "A technical error has occurred! Please send a screenshot to IT.",
    l_Those_whose_weight_is_over_31_kg: "Those whose weight is over 31 kg",
    l_The_price_is_more_than_1000: "The price is more than 1000$",
    l_Price_over_1000_and_weight_over_31_kg: "Price over 1000$ and weight over 31kg",
    l_Net_weight: "Net weight",
    l_Overall_weight: "Overall weight",
    l_History: "History",
    l_Updated_time: "Updated time",
    l_Order_count: "Order count",
    l_Unknown: "Unknown",
    l_Mini_batch_count: "Mini batch count",
    l_Return_order: "Return order",
    l_Change_branch: "Change branch",
    l_Image: "Image",
    l_Search_in_shelf: "Search in shelf",
    l_Translation: "Translation",
    l_Primary_language: "Primary language",
    l_Content: "Content",
    l_Translated_language: "Translated language",
    l_Check_the_category_of_KTZ: "Check the category of KTZ",
    l_There_is_KTZ_category: "There is a KTZ category",
    l_There_is_no_category_KTZ: "There is no category KTZ",
    l_Are_you_sure_of_the_correctness_of_the_data: "Are you sure of the correctness of the data?",
    l_Statistic: "Statistic",
    l_China_warehouse: "China warehouse",
    l_Sorting: "Sorting",
    l_Role: "Role",
    l_Stay_branch_day: "Stay branch day",
    l_Min_weight: "Min weight",
    l_Menu: "Menu",
    l_Left_from_Almaty: "Left from Almaty",
    l_Left_from_China: "Left from China",
    l_Almaty_warehouse_received: "Almaty warehouse received",
    l_China_warehouse_received: "China warehouse received",
    l_Jpid_build_by_minibatch: "Jpid built by minibatch",
    l_Weighed_id: "Weighed id",
    l_Close: "Close",
    l_Article: "Article",
    l_Employees: "Employees",
    l_Visibility: "Visibility",
    l_Can_view: "Can view",
    l_Admin_worker: "Admin worker",
    l_Web: "Web",
    l_General: "General",
    l_Door_to_door: "Door to door",
    l_Pending_orders: "Pending orders",
    l_In_delivery: "In delivery",
    l_Received: "Received",
    l_Reject: "Reject",
    l_Pending: "Pending",
    l_Supervision: "Supervision",
    l_Language: "Language",
    l_Agent: "Agent",
    l_My_Statistics: "My Statistics",
    l_Count_Stats: "Count  Statistics",
    l_Number_of_products_that_do_not_match_the_branch: "Number of products that do not match the branch",
    l_Quantity_of_goods: "Quantity of goods",
    l_Delivery_to_me: "Delivery to me",
    l_Batch_statistics: "Batch statistics",
    l_Returned_to_China_Courier: "Returned to China Courier",
    l_Feedback: "Feedback",
    l_Accepted: "Accepted",
    l_In_progress: "In progress",
    l_Weight_change_history: "Weight change history",
    l_Public_document: "Public document",
    l_Recovery: "Recovery",
    l_Logistic: "Logistic",
    l_Regional_center: "Regional center",
    l_Internal_logistics: "Internal logistics",
    l_Branch: "Branch",
    l_Dont_match: "Dont match",
    l_Additional_document: "Additional document",
    l_Weight_difference: "Weight difference",
    l_Dead_goods: "Dead goods",
    l_List: "List",
    l_Result: "Result",
    l_Reason: "Reason",
    l_Negotiate_order_prices: "Negotiate order prices",
    l_Negotiate_road_prices: "Negotiate road prices",
    l_Bank_account: "Bank account",
    l_Finish: "Finish",
    l_Revise: "Revise",
    l_Alert_on_revision: "Revision time has not started",
    l_Save: "Save",
    l_Create: "Create",
    l_Schedule: "Schedule",
    l_Coming: "Coming",
    l_Reception: "Reception",
    l_Put_on_the_shelf: "Put on the shelf",
    l_Distribution: "Distribution",
    l_Average_weight: "Average weight",
    l_Dependent_region: "Dependent region",
    l_Reset_permission: "Reset permission",
    l_Cannot_be_deleted: "Cannot be deleted",
    l_Region: "Region",
    l_Operator_statistic: "Operator statistic",
    l_People_who_uploaded_the_document: "People who uploaded the document",
    l_Reset: "Reset",
    l_Rejected_order: "Rejected order",
    l_Warning_Has_an_impact_on_statistics: "Warning! Has an effect on statistics.",
    l_Fragile_products: "Fragile products",
    l_Work_schedule: "Work schedule",
    l_Sorting_machine: "Sorting machine",
    l_Unique: "Unique",
    l_Repeated: "Repeated",
    l_Machine: "Machine",
    l_App_service: "App service",
    l_Order_status: "Order status",
    l_In_several_branches: "In several branches",
    l_Not_in_database: "Not in database",
    l_Correct: "Correct",
    l_Revision: "Revision",
    l_Ticket: "Ticket",
    l_Detail: "Detail",
    l_Answer: "Answer",
    l_Receive_client: "Receive from client",
    l_Work_order: "Work order",
    l_Order_code: "Order-code",
    l_Send_address: "Send address",
    l_Receive_name: "Receive name",
    l_Receive_contact: "Receive contact",
    l_Receive_address: "Receive address",
    l_Express_Company_Id: "Express company id",
    l_Express_Dealer: "Express Dealer",
    l_Express_Dealer_Contact: "Express Daaler contact",
    l_Compensate_Amount: "Compensate amount",
    l_Reply_type: "Reply type",
    l_Handle_result: "Handle result",
    l_Call_result: "Call result",
    l_Pay_amount: "Goods price",
    l_Compensate_state: "Compensate state",
    l_sign_state: "Sign state",
    l_Replied: "Replied",
    l_Not_replied: "Not replied",
    l_Orders_in_shelf: "Orders in shelf",
    l_Tariff: "Tariff",
    l_Filter_settings: "Setting up filters",
    l_PDD_received: "PDD received",
    l_Wallet: "Wallet",
    l_Bonus: "Bonus",
    l_Refund_account: "Responsible for return",
    l_Duty: "Duty",
    l_The_call_was_connected_but_there_was_no_response: "The call was connected, but there was no response",
    l_Wrong_number: "Wrong nomber ",
    l_Phone_is_busy: "Phone is busy",
    l_No_response: "No response",
    l_Other_person: "Other person",
    l_By_default: "By default",
    l_Not_signed: "Not signed",
    l_Signed: "Signed",
    l_Cargo_company: "Cargo company",
    l_Seller: "Seller",
    l_Will_not_compensate: "Not compensated",
    l_Will_compensate: "Compensated",
    l_Answered: "Answered",
    l_Replied_at: "Replied time",
    l_Consumer: "Consumer",
    l_Multi: "Multi",
    l_Normal: "Normal",
    l_Added_to_task: "Added to task",
    l_Big_box: "Big box",
    l_Task: "Task",
    l_Has: "Has",
    l_None: "None",
    l_All_answers: "All answers",
    l_Already_scanned: "Already scanned!",
    l_Terminal: "Terminal",
    l_The_branch_does_not_match: "The branch does not match",
    l_End_time: "End time",
    l_Left: "Left",
    l_Reached_the_center: "Reached the center",
    l_Left_from_the_center: "Left from the center",
    l_Scan_time: "Scan time",
    l_App_news: "App news",
    l_Title: "Title",
    l_Check_list: "Checklist",
    l_Total_average: "Total average score",
    l_Operation_JPID: "Operation JPID",
    l_Average_score: "Average score",
    l_Criteria_name: "Criteria name",
    l_Score: "Score",
    l_Check_list_add: "Add checklist",
    l_Criteria_add: "Add criteria",
    l_Checked_date: "Cheched date",
    l_User_restore: "User restore",
    l_App_articles: "App articles",
    l_Partner: "Partner",
    l_News: "News",
    l_Lost: "Lost",
    l_Video: "Video",
    l_Statement: "Statement",
    l_Serve_speed: "Serve speed",
    l_Send_by_file: "Send by file",
    l_Send_one: "Send one",
    l_Late_goods: "Late goods",
    l_Warehouse_payment: "Warehouse payment",
    l_Registration: "Registration",
    l_Destroy: "Destroy",
    l_Sold: "Sold",
    l_Burned: "Burned",
    l_Rework: "Rework",
    l_Scan_with_app: "Scan using the Jana Post app",
    l_Send: "Send",
    l_Destroyed: "Destroyed",
    l_Questions: "Questions",
    l_Question: "Question",
    l_Rating: "Rating",
    l_Star: "Star",
    l_Sender: "Sender",
    l_Rate_type: "Rate type",
    l_Rate_question: "Rate question",
    l_Worker: "Worker",
    l_Delivery: "Delivery time",
    l_File_must_be_less_than_5_MB: "File must be less than 5 MB!",
    l_Finish_sorting: "Finish sorting",
    l_Barcode: "Barcode",
    l_Inner_logistic_finish: "Inner logistic finish",
    l_Table: "Table",
    l_Charts: "Charts",
    l_Option: "Option",
    l_Options: "Options",
    l_Results: "Results",
    l_Partners: "Partners",
    l_Resume: "Resume",
    l_Finance: "Finance",
    l_Scanzona: "Scanzona",
    l_Scanned_in_zona: "Scanned in zona",
    l_Complaints: "Complaints",
    l_Responsible_department: "Responsible department",
    l_User_feedback: "User feedback",
    l_Transportation_time: "Transportation time",
    l_Hour: "Hour",
    l_Employee_discount: "Employee discount",
    l_Add_filials: "Add filials",
    l_Filial_list: "Filial list for partners",
    l_Partnership: "Partnership",
    l_Count: "Count for per city",
    l_Branches_for_partners: "Filials for partners",
    l_Plomb: "Plomb",
    l_Latitude: "Latitude",
    l_Longitude: "Longitude",
    l_By_file: "By file",
    l_By_filter: "By filter",
    l_User_count: "User count",
    l_Name_fill: "Your full name",
    l_Address_fill: "",
    l_individualEntrepreneur: "Are you individual entepreneur?",
    l_Address_link: "Please insert your 2GIS address link",
    l_Have_you_ordered: "Have you ordered before? If yes, left your order JPID",
    l_Open_your_own_branch: "Open your own branch",
    l_Based_on_your_current_location_are_you_in_Kazahstan: "Based on your current location, you are in Kazakhstan",
    l_Based_on_your_current_location_are_you_in_Uzbekistan: "Based on your current location, you are in Uzbekistan",
    l_Based_on_your_current_location_are_you_in_Kyrgyzstan: "Based on your current location, you are in Kyrgyzstan",
    l_Based_on_your_current_location_are_you_in_Tajikistan: "Based on your current location, you are in Tajikistan",
    l_Based_on_your_current_location_are_you_in_Mongolia: "Based on your current location, you are in Mongolia",
    l_Continue: "Continue",
    l_Access_to_geodata_is_not_allowed: "Access to geodata is not allowed. Unable to determine location",
    l_Location_information_is_unavailable: "Location information is unavailable.",
    l_your_bday: "Your birthday",
    l_knowledge: "Your level of education",
    l_is_there_experience: "Have you ever had ewperience in business?",
    l_is_there_2million: "Do ypu have at least 2 millions to open a branch?",
    l_Lower: "By spesiality",
    l_Middle: "Middle level",
    l_Upper: "Upper level",
    l_Add_partners: "Add partners",
    l_Communication: "Communication",
    l_Area_covered: "Area covered",
    l_Document_service: "Document service",
    l_The_shelf_number_should_start_with_JP: "The shelf number should start with JP",
    l_All_near_branches: "All near branches",
    l_Important: "Important",
    l_New_station: "New station",
    l_Branch_near_by: "Branch near by",
    l_Branch_open_warehouse: "All opened branches",
    l_Need_branch: "Need to choose branch",
    l_Daily_Count_Stats: "Daily count statistic",
    l_Agreement_branch: "Agreement Branch",
    l_Agreement_sign: "Agreement Sign",
    l_Batch_not_installed: "Batch not installed",
    l_Excel_print: "Print Excel (orders)",
    l_Reading_list: "Reading list",
    l_Marketing: "Marketing",
    l_Number: "Number",
    l_Home_delivery: "Home delivery",
    l_Matching: "Matching",
    l_Track_analytic: "Track analytic",
    l_Call_center: "Call center",
    l_On_the_shelf: "On the shelf",
    l_Delivered: "Delivered",
    l_Available_offers: "Available offers",
    l_Courier: "Courier",
    l_Enabled: "Enabled",
    l_Disabled: "Disabled",
    l_Identification_to_branch: "identification to branch",
    l_Personal: "Personal",
    l_Finished_the_job: "Finished the job",
    l_Completeness: "Completeness",
    l_Timeliness: "Timeliness",
    l_Timeliness_24h: "Timeliness 24h",
    l_On_time_delivery: "On time delivery",
    l_On_time: "On time",
    l_Late: "Late",
    l_Total: "Total",
    l_Percent: "Percent",
    l_Margin: "Margin",
    l_Loss: "Loss",
    l_Income: "Income",
    l_Today: "Today",
    l_Yesterday: "Yesterday",
    l_Day_before_yesterday: "Day before yesterday",
    l_Last_status: "Last status",
    l_Static_tracks: "Static tracks",
    l_Mini_batch_destination: "Destination of the M-Batch",
    l_Not_matched_stations: "Not matched orders with Stationcode",
    l_Count_order_mbatch: "Count of orders in M-Batch",
    l_No_branches_choosed: "No branch choosed",
    l_Agree_to_change_branches: "With agreeing with this, you will change branches of this orders to this M-Btach's choosen branch",
    l_Change: "Change",
    l_Preparation_for_distribution: "Preparation for distribution",
    l_Distribution_to_the_basket: "Distribution to the basket",
    l_Coordinate_status: "Coordinate status",
    l_Delivery_status: "Delivery status",
    l_Number_of_baskets: "Number of baskets",
    l_Basket_add: "Basket add",
    l_Basket_number: "Basket number",
    l_Courier_reseived: "Courier received",
    l_Courier_didnt_reseived: "Courier didn't received",
    l_Courier_jpcr: "Courier JPCR",
    l_Need_to_scan_the_courier_JPCR: "Need to scan the courier JPCR",
    l_Need_to_scan_the_basket_number: "Need to scan the basket number",
    l_First_scan_the_basket_number_to_check_the_status: "First scan the basket number to check the status",
    l_Last_time: "Last time",
    l_Clear: "Clear",
    l_Basket_list: "Basket list",
    l_Withdrawal_of_an_order: "Withdrawal of an order",
    l_Basket: "Basket",
    l_Adding_an_order_to_the_shelf: "Adding an order to the shelf",
    l_Distribution_of_the_order_in_the_basket: "Distribution of the order in the basket",
    l_Couriers: "Couriers",
    l_To_divide_the_basket_you_need_to_add_the_order_to_the_shelf: 'To allocate the order to the basket, the order must be added to the shelf or the delivery status must be "Preparing allocation" !',
    l_Only_those_whose_coordinates_are_found_are_allocated_in_the_basket: "Only those whose coordinates are found are allocated in the basket",
    l_Orders_in_the_basket: "Orders in the basket",
    l_Courier_refused: "Courier refused",
    l_Recommended_basket: "Recommended basket",
    l_Number_of_goods_in_preparation_for_distribution: "Number of goods in preparation for distribution",
    l_Frozen_state: "Frozen state",
    l_Be_careful_when_freezing_the_order: "Be careful when freezing the order !",
    l_Branch_orders: "Branch orders",
    l_Problem_description: "Problem description",
    l_Go_to_website: "Go to website",
    l_Invite_list: "Invite list",
    l_Inviter_JPID: "Inviter JPID",
    l_Add_order_to_the_Basket: "Add the order to the basket",
    l_Preparing_the_basket_in_the_order: "Preparing the order in the basket",
    l_Write_the_number_of_the_basket_where_the_orders_will_be_placed: "Write the number of the basket where the orders will be placed!",
    l_Order_withdrawal_from_courier: "Order withdrawal from courier",
    l_Distribution_of_the_order_to_the_courier_shelf: "Distribution of the order to The Courier shelf",
    l_Courier_shelf_list: "Courier shelf list",
    l_Orders_on_the_courier_shelf: "Orders on the courier shelf",
    l_Placing_the_order_on_the_courier_shelf: "Placing the order on the courier shelf",
    l_Courier_shelf_number: "Courier shelf number",
    l_Preparing_the_order_for_the_courier_shelf: "Preparing the order for the courier shelf",
    l_Adding_an_order_to_the_courier_shelf: "Adding an order to the courier shelf",
    l_Place_on_the_courier_shelf: "Place on the courier shelf",
    l_Allocation_to_the_courier_rack: "Allocation to the courier rack",
    l_Division_into_shelves: "Division into shelves",
    l_Shipping_price: "Shipping price",
    l_Cost_price: "Cost price",
    l_NORTH: "NORTH",
    l_SOUTH: "SOUTH",
    l_WEST: "WEST",
    l_EAST: "EAST",
    l_Over45days: "Over 45 days",
    l_Text: "Text",
    l_Order_rectify: "Rectify order",
    l_Not_received: "Not received",
    l_Department: "Department",
    l_Operation_time: "Operation time",
    l_Tracks: "Tracks",
    l_Adding_a_courier_order: "Adding a courier order",
    l_Sending_to_courier: "Sending to courier",
    l_Regulation: "Regulation",
    l_Orders_that_should_be_frozen: "Orders that should be frozen",
    l_On_the_courier: "On the courier",
    l_Goods_older_than_15_days: "Goods older than 15 days",
    l_Frozen: "Frozen",
    l_Late_delivered_orders: "Late delivered orders",
    l_Number_of_days: "Number of days",
    l_Undelivered_goods: "Undelivered orders",
    l_More_details: "More details",
    l_Client_received: "Client received",
    l_Stuck_orders: "Stuck orders",
    l_Check: "Check",
    l_District: "District",
    l_Store: "Store",
    l_Route: "Route",
    l_Branch_batch_count: "Branch batch count",
    l_Last_freeze_day: "Last freeze day",
    l_Level: "Level",
    l_Undelivered: "Undelivered",
    l_New_user: "New user",
    l_Sending_a_verification_code_to_the_client: "Sending a verification code to the client",
    l_Confirmation_code: "Confirmation code",
    l_Transit_count: "Transit count",
    l_Wrong_tracks: "Wrong tracks",
    l_Normal_tracks: "Normal tracks",
    l_Goods_lost_or_broken: "Goods lost or broken",
    l_Load_data: "Load data",
    l_China_storage: "China storage",
    l_Inner_logistics: "Inner logistics",
    l_Warning: "Warning",
    l_Penalty: "Penalty",
    l_Day_left_to_return: "Day left to return",
    l_Reason_for_rejection: "Reason for rejection",
    l_Rejection: "Rejection",
    l_DepartmentId: "DepartmentId",
    l_Patronymic: "Patronymic",
    l_Inviter: "Inviter",
    l_Awaiting_a_refund: "Awaiting a refund",
    l_Send_push_message: "Send push message",
    l_Order_search: "Order search",
    l_Unclaimed_goods: "Unclaimed goods",
    l_Confirm_Modify: "Confirm modify",
    l_Payment_time: "Payment time",
    l_Exported: "Dispatched",
    l_Arrival_transfer_center: "Arrived at transfer center (Khorgos)",
    l_Export_clearance_start: "Export customs clearance started",
    l_Export_clearance_finish: "Export customs clearance completed",
    l_Departure_foreign: "Departed from abroad",
    l_Reached_Kazakhstan: "Arrived in Kazakhstan",
    l_Import_clearance_start: "Import customs clearance started",
    l_Import_clearance_finish: "Import customs clearance completed",
    l_Package_status: "Package status",
    l_Arrival_branch: "Arrived to branch",
    l_KZ_mini_batch_products: "KZ mini batch products",
    l_Scanned: "Scanned",
    l_More: "More",
    l_Registered_user: "Registered user",
    l_Copied: "Copied!",
    l_The_first: "The first",
    l_Current: "Current",
    l_JPID_change_history: "JPID change history",
    l_Change_weight: "Change weight",
    l_Not_exists: "Not exists",
    l_Total_refund_price_usd: "Enter total refund amount",
    l_Order_finish_warning: "The order cannot be modified after completion. Please review carefully before submitting!",
    l_Client_address: "Client's address",
    l_Client_history: "Client's history",
    l_Order_history: "Order's history",
    l_Change_JPID: "Change JPID",
    l_New: "New",
    l_Old: "Old",
    l_Order_JPID_history: "JPID change history",
    l_Order_branch_history: "Branch change history",
    l_Client_branch_history: "Client branch change history",
    l_Day_delivered: "day delivered",
    l_Day_delivering: "day delivering",
    l_Door: "Door",
    l_Free_shipping: "Free shipping",
    l_Status_history: "Status history",
    l_Transit_branch: "Transit branch",
    l_Failed_to_copy: "Failed to copy",
    l_Please_enter: "Please enter",
    l_Max_day_count: "Maximum day count",
    l_Branch_statistic: "Branch statistic",
    count: "Count",
    ARRIVAL_BRANCH: "Arrived branch",
    WAIT: "Waiting",
    ARRIVAL_SHELF: "Arrived to shelf",
    INNER_LOGISTICS_FINISH: "Inner logistics finished",
    DELIVERED: "Delivered",
    RETURN: "Returned",
    l_Payment_complaint: "Payment complaint",
    l_Copy: "Copy",
    l_Hidden: "Hidden",
    l_Are_you_sure_you_want_to_perform_this_action: "Are you sure you want to perform this action?",
    l_Show_order_to_client: "Through this action, the order will be visible to the client again!",
    l_Courier_operation: "Courier operation",
    l_Start_date: "Start date",
    l_End_date: "End date",
    l_The_client_agreed: "The client agreed",
    l_Cancelled: "Cancelled",
    l_Te_client_refused: "Client refused",
    l_Cancel2: "Cancel",
    l_Additional_payment: "Additional payment",
    l_Additional_packaging: "Additional packaging",
    l_China_inner_logistics: "China inner logistics",
    l_Payment_type: "Payment type",
    l_Error_500: "Internal server error. Please try again later.",
    l_Show_more: "Show more",
    l_Oversized: "Oversized",
    l_Overweight: "Overweight",
    l_Transport_restrictions: "Transport restrictions",
    l_Cash_on_delivery: "Cash on delivery",
    l_Non_original_packaging: "Non-original packaging",
    l_Return_requested: "Return requested",
    l_Damaged: "Damaged",
    l_Pre_creation_reject: "Pre-creation reject",
    l_Sent_for_feedback: "Sent for feedback",
    l_In_search: "In search",
    l_Found: "Found",
    l_More_than_72_hours: "More than 72 hours",
    l_Weight_measured: "Weight measured",
    l_Avg_measure_duration: "Average measure duration",
    l_China_courier_operation: "China courier operation",
    l_Code_wrong: "Wrong code",
    l_Returned_order: "Returned order",
    l_Wrong_address: "Wrong address",
    l_Warehouse_not_accepted: "Warehouse not accepted",
    l_Wrong_client: "Wrong client",
    l_China_warehouse_shelf: "Arrival shelf in China warehouse",
    l_Deleted: "Deleted",
    l_Found_time: "Found time",
    l_Measure_duration: "Measure duration",
    l_Weight_measured_time: "Weight measured time",
    l_Found_items: "Found items",
    l_Weight_not_measured: "Weight not measured",
    l_Overdue_sla_72h: "Overdue 72h",
    l_Dashboard_period: "Dashboard period",
    l_Enter_track_code: "Enter track code",
    l_Enter_jpid: "Enter JPID",
    l_Promocode: "Promo code",
    l_Registered: "Registered",
    l_Inviter_user: "Inviter",
    l_Invited_by: "Invited by",
    l_Invited_friends: "Invited friends",
    l_Friend: "Friend",
    l_Promo_code_entered: "Used promo code",
    l_Expired_bonus: "Expired bonus",
    l_Total_accrued: "Total accrued",
    l_Referral_balance: "Invite friends balance",
    l_First_delivery: "First delivery",
    l_Not_placed_yet: "Not placed yet",
    l_Used_promocode: "Used promo code",
    l_Used_bonus: "Used bonus",
    l_Bonus_statuses: "Bonus statuses",
    l_Expired: "Expired",
    l_Promo_type_user: "USER",
    l_After_registration: "After registration",
    l_First_delivery_bonus_hint: "The first delivery bonus is credited after the parcel is registered at the China warehouse",
    l_For_first_delivery: "For the first delivery",
    l_First_delivery_deadline: "First delivery deadline",
    l_Promo_type: "Type",
    l_Inviting_client: "Inviting client",
    l_Deadline_until: "Deadline",
    l_Promo_type_system: "SYSTEM",
    l_Accrued: "Accrued",
    l_Not_accrued: "Not accrued",
    l_Placed: "Delivered",
    l_Minutes_short: "min",
    l_Hours_short: "hrs",
    l_Days_short: "days",
    l_Days_left: "days left",
    l_Registration_type: "Registration type",
    l_Automatic: "Automatic",
    l_Manual: "Manual",
    l_Rejected_orders: "Rejected orders",
    l_Died_orders: "Died orders (DIED)",
    l_Branch_2_door: "Branch-Door",
}
